const toNumberOrNull = val => (val === null || val === undefined || val === '' ? null : parseFloat(val));
export default toNumberOrNull;
